{
	"name": "onjoss-admin",
	"private": true,
	"version": "1.0.7",
	"type": "module",
	"scripts": {
		"dev": "vite",
		"build": "vite build",
		"lint": "eslint . --report-unused-disable-directives --max-warnings 0",
		"preview": "vite preview"
	},
	"dependencies": {
		"@radix-ui/react-avatar": "^1.3.1",
		"@radix-ui/react-checkbox": "^1.4.1",
		"@radix-ui/react-dialog": "^1.3.1",
		"@radix-ui/react-dropdown-menu": "^2.2.1",
		"@radix-ui/react-label": "^2.1.17",
		"@radix-ui/react-menubar": "^1.2.1",
		"@radix-ui/react-popover": "^1.3.1",
		"@radix-ui/react-scroll-area": "^1.4.0",
		"@radix-ui/react-select": "^2.4.1",
		"@radix-ui/react-separator": "^1.2.0",
		"@radix-ui/react-slider": "^1.6.1",
		"@radix-ui/react-slot": "^1.5.0",
		"@radix-ui/react-switch": "^1.4.1",
		"@radix-ui/react-tabs": "^1.2.1",
		"@radix-ui/react-tooltip": "^1.4.1",
		"@react-oauth/google": "^0.13.5",
		"@sentry/react": "^11.10.0",
		"@tanstack/react-query": "^5.105.0",
		"apisauce": "^3.2.2",
		"class-variance-authority": "^0.7.1",
		"clsx": "^2.1.1",
		"country-flag-icons": "^1.6.20",
		"date-fns": "^4.4.0",
		"dayjs": "^1.11.23",
		"i18n-iso-countries": "^7.14.0",
		"jwt-decode": "^4.0.0",
		"lucide-react": "^1.66.0",
		"nuqs": "^2.10.2",
		"react": "^19.3.1",
		"react-confirm": "^0.5.0",
		"react-day-picker": "^10.0.2",
		"react-dom": "^19.3.1",
		"react-hook-form": "^7.91.0",
		"react-photo-view": "^1.2.7",
		"react-router-dom": "^7.18.5",
		"rxjs": "^7.8.2",
		"sonner": "^2.0.8",
		"swr": "^2.5.1",
		"tailwind-merge": "^3.7.0",
		"tailwindcss-animate": "^1.0.7",
		"zustand": "^5.0.16"
	},
	"devDependencies": {
		"@biomejs/biome": "^2.6.4",
		"@eslint/js": "^10.0.1",
		"@tailwindcss/postcss": "^4.3.3",
		"@types/node": "^26.6.6",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"@vitejs/plugin-react": "^6.1.2",
		"eslint": "^10.14.0",
		"eslint-plugin-react-hooks": "^7.1.1",
		"eslint-plugin-react-refresh": "^0.5.7",
		"globals": "^17.13.0",
		"postcss": "^8.5.32",
		"tailwindcss": "^4.3.3",
		"typescript": "^6.0.3",
		"typescript-eslint": "^8.72.1",
		"vite": "^8.3.5"
	}
}
